import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
// import Right from '../right/Right';
import './ColoringPage.css';
import { fetchInitialData3 } from "../fetchData";
import CatMenuDesktop from './common/CatMenuDesktop';
import ColoringDesktopView from './common/ColoringDesktopView';
import ColoringMobileView from './common/ColoringMobileView';
import NoResult from './common/NoResult';
import * as action from './Actions';
import Service from '../service/Service';
import withLocation from "../../withLocation";
const service = new Service();
import { AdSlot, DFPSlotsProvider } from 'react-dfp'
import withContext from "../../withContext";

// import { Bling as GPT } from "react-gpt";

const gptAry = {
    "msite": {
        path: "/84382175/parenting.com/Parenting.com_ColoringPages_Msite_Description_336x280",
        slot: [[310, 100], [320, 50], [300, 250]],
        id: "div-gpt-ad-1671527726123-0",
    },
    "desktop": {
        path: "/84382175/parenting.com/Parenting.com_ColoringPages_Desktop_BelowCatMenu_160x600",
        // slot: [[310, 100], [320, 50], [300, 250]],
        slot: [160,600],
        id: "div-gpt-ad-1693281425170-0",
    }
}

class ColoringSubCatDetails extends Component {
    constructor(props) {
        super(props);
        console.log("ColoringSubCatDetails Page Loaded !!")
        // this.catName = props.match.params.catName;
        let initialData = [];
        let serverSideData = {};
        let categoryList = [];
        let otherCategoryList = [];
        let categoryListAlphabeticaly = [];
        let filterSubCategory = [];
        let filterMainCategory = [];
        var selectedDeskCat = "";
        var selectedCatAry = [];
        var selectedCatAryMain = [];
        var seoData = [];
        var CatNameBreadcrm = '';
        var urlpageNo = 1;
        if (__isBrowser__) {
            console.log("[DEBUG] Running in browser context");
            console.log("[DEBUG] window.__initialData__", window.__initialData);
        
            if (window.__initialData__ && window.__initialData__['initialData']) {
                console.log("[DEBUG] Found initialData in window.__initialData__");
                serverSideData = window.__initialData__['initialData'];
                console.log("[DEBUG] serverSideData set from window.__initialData__", serverSideData);
        
                delete window.__initialData__;
                console.log("[DEBUG] window.__initialData__ deleted");
            } else {
                console.log("[DEBUG] No valid initialData found in window.__initialData__");
            }
        } else {
            console.log("[DEBUG] Running in server-side context");
            console.log("[DEBUG] props.staticContext", props.staticContext);
        
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                console.log("[DEBUG] Found initialData in props.staticContext");
                serverSideData = props.staticContext.initialData['initialData'];
                console.log("[DEBUG] serverSideData set from props.staticContext.initialData", serverSideData);
            } else {
                console.log("[DEBUG] No valid initialData found in props.staticContext");
            }
        }
        
        console.log("serverSideData -134-- ", serverSideData);
        
        if (serverSideData) {
            if (serverSideData['data1'] && serverSideData['data1']['msg'] == 1) {
                selectedCatAry = serverSideData['data1']['subCategory'];
                selectedCatAryMain = serverSideData['data1']['categoryName'];
                otherCategoryList = serverSideData['data1']['otherCategories'];
                seoData = serverSideData['data1']['seoData'];

            }
            if (serverSideData['data2'] && serverSideData['data2']['msg'] == 1) {
                categoryList = serverSideData['data2']['result'][0];
            }
            if (serverSideData['data3'] && serverSideData['data3']['msg'] == 1) {
                categoryListAlphabeticaly = serverSideData['data3']['result'];
            }
        }

        if (serverSideData['data1'] && serverSideData['data1']['msg'] == 1) {

            if (serverSideData['data1']['categoryName']) {
                selectedDeskCat = selectedCatAryMain[0].categoryName;
                initialData[0] = {
                    categoryId: selectedCatAryMain[0].categoryId,
                    categoryName: selectedCatAryMain[0].categoryName,
                    subcategory: selectedCatAry
                }
            } else {
                selectedDeskCat = "";
                initialData[0] = {
                    categoryId: "",
                    categoryName: "",
                    subcategory: selectedCatAry
                }
            }
        }
        var urlParam = (props.location.pathname + props.location.search);
        console.log("urlParam======>", urlParam);
        if (urlParam && urlParam.split("/")[2]) {
            CatNameBreadcrm = urlParam && urlParam.split("/")[2];
            CatNameBreadcrm = CatNameBreadcrm.replace(/-/g, " ");
            if(CatNameBreadcrm.includes("and")){
                CatNameBreadcrm = CatNameBreadcrm.replace(/and/g,"&");
            }
            CatNameBreadcrm = CatNameBreadcrm && CatNameBreadcrm.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
          
        }
        this.state = {
            page: (seoData && seoData != "") ? seoData[0].pageTitle : '',
            metaTitle: (seoData && seoData != "") ? seoData[0].pageTitle : '',
            metaDescription: [{ "name": "description", "content": (seoData && seoData != "") ? seoData[0].metaDescription : '' }, { "name": "keywords", "content": (seoData && seoData != "") ? seoData[0].metaKeywords : '' }],
            seoData: seoData,
            initialData: initialData,
            categoryList: categoryList,
            otherCategoryList: otherCategoryList,
            showMsiteCat: false,
            selectedDeskCat: selectedDeskCat,
            categoryListAlphabeticaly: categoryListAlphabeticaly,
            filterSubCategory: filterSubCategory,
            filterMainCategory: filterMainCategory,
            filterCategoryId: '',
            filterSearchVal: '',
            mainCategoryCont: urlpageNo,
            selectedCatAry: initialData,
            CatNameBreadcrm : CatNameBreadcrm,
            isApp: false
        };

        this.qnaPageNo = 1;
        this.maxScroll = 0;
        this.timeout = 0;
        if (selectedCatAry) {
            if (selectedCatAry.length > 9) {
                this.totalCount = 20;
            } else {
                this.totalCount = selectedCatAry.length;
            }
        } else {
            this.totalCount = 0;
        }

        // this.totalCount = 20;
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var cUrl = reqUrl;
        // if (reqUrl.split('?id=')) {
        //     var pageNo =  cUrl.split('?id=')[1];
        // }else{
        //     var pageNo =  1;
        // }
        if (cUrl.includes('?')) {
            cUrl = cUrl.split('?')[0];
        }
        if (cUrl.includes('#')) {
            cUrl = cUrl.split('#')[0];
        }
        var catName = cUrl.split('/')[3];
        catName = catName.split("-").join(" ");
        /*let obj2 = {
            url: global.api_url + "colouringpages/getothercategories",
            body: JSON.stringify({
                "subcategoryId": catId,
                "pageno": 1,
                "pagesize": 10
            })
        };*/


        let obj1 = {
            url: global.api_url + "colouringpages/getothercategories",
            body: JSON.stringify({
                "subcategoryName": catName,
                "pageno": 1,
                "pagesize": 10
            })
        };
        let obj2 = {
            url: global.api_url + "colouringpages/getallmaincategory",
            body: JSON.stringify({
                "pageno": 1,
                "pagesize": 100
            })
        };
        let obj3 = {
            url: global.api_url + "colouringpages/getallmaincategorynsubcatcount",
            body: JSON.stringify({
                "pageno": 1,
                "pagesize": 10
            })
        };
        return fetchInitialData3(obj1, obj2, obj3, JSON.stringify(header));
        // return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }

    componentDidMount() {
        this.setState({ windowWidth: window.outerWidth });
        this.setState({ windowInner: window.innerWidth });
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        // debugger;
        if (document.querySelector(".top-category-descp")) {
            if (document.querySelector(".top-category-descp").offsetHeight <= 40) {
                document.querySelector(".read-more-less").style.display = "none";
            } else {
                document.querySelector(".top-category-descp").style.height = "42px";
                document.querySelector(".top-category-descp").classList.add("line-clamp");
            }
        }
        if (this.props.location.search.includes('from=app')) {
            this.setState({ isApp: true });
        }
    }

    opendropdown() {
        this.setState({ showMsiteCat: !this.state.showMsiteCat });
    }

    selectDeskCat(list) {
        var selectedCatAry = this.state.initialData.filter(function (item) {
            return item.categoryName == list.categoryName;
        });
        this.setState({
            selectedDeskCat: list.categoryName,
            selectedCatAry: selectedCatAry
        })
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
    }

    pageData() {
        console.log("qnaPageNo -- ", this.qnaPageNo);
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('subcategory-list')[0]) {
                var cS = document.getElementsByClassName('subcategory-list')[0].offsetTop;
                var cH = document.getElementsByClassName('subcategory-list')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.qnaPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.qnaPageNo;
                        service.showLoader();
                        document.getElementById('pgNo').value = _this.qnaPageNo;
                        _this.catData(_this.qnaPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    catData(pageno, size) {
        var catName = this.props.location.pathname.split("?")[0].split('/')[3];
        catName = catName.split("-").join(" ");

        let postData = {
            "subcategoryName": catName,
            "pagesize": size,
            "pageno": pageno
        }


        var url = global.api_ci_url + "coloringpages/getothercategories";
        service.postServiceCall(url, postData).then((json) => {
            // debugger;
            console.log("SubcatData -- ", json.subCategory);
            if (json.msg == "1") {
                if (this.state.initialData[0].subcategory && this.state.initialData[0].subcategory.length > 0 && json.subCategory) {
                    if (json.subCategory.length > 9) {
                        this.totalCount = this.totalCount + 10;
                    }
                    let tempInitialData = [];
                    tempInitialData[0] = {
                        categoryId: this.state.initialData[0].categoryId,
                        categoryName: this.state.initialData[0].categoryName,
                        subcategory: this.state.initialData[0].subcategory.concat(json.subCategory)
                    }

                    // this.setState({ otherCategoryList: this.state.otherCategoryList.concat(json.otherCategoryList) });
                    this.setState({ selectedCatAry: tempInitialData });
                    this.setState({ initialData: tempInitialData });
                    // console.log("-------selectedCatAry selectedCatAry1:::: ",tempInitialData);
                }

            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    render() {
        return (
            <div>
                <main className="main-container colouring-page colouring-page-catdetail">
                    <Helmet
                        title={this.state.metaTitle}
                        meta={this.state.metaDescription}
                    />
                    <div className="left">
                        <CatMenuDesktop eleRef={this} mainCategoryCont={this.state.mainCategoryCont} />
                        {!this.state.isApp ? <div className="lhs-desktop-ad" role="img" aria-label="Advertisement unit" tabIndex={0}>
                            <div style={{ textAlign: "center", padding: "5px" }} >ADVERTISEMENT</div>
                            {/* <GPT
                                adUnitPath={gptAry['desktop']['path']}
                                slotSize={gptAry['desktop']['slot']}
                                renderWhenViewable={false}
                            /> */}
                             <DFPSlotsProvider
                                dfpNetworkId={gptAry['desktop']['id']}
                                adUnit={gptAry['desktop']['path']}
                                slotSize={gptAry['desktop']['slot']}
                                renderWhenViewable={false}
                            ></DFPSlotsProvider>
                        </div> : ''}
                        
                    </div>
                    <div className="colouringpage-content left">
                        <div className="title">
                            {!this.state.isApp &&
                            <div className="breadcrumb R11_9e">
                                <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                                <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                <span><a href={service.getRedirectUrl("/coloring-pages-printables/")} className="R11_9e">Coloring Pages & Printables</a></span>
                                <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                <span><a href={service.getRedirectUrl(`/coloring-pages-printables/${this.props.location.pathname.split("?")[0].split('/')[2]}/`)} className="R11_9e">{this.state.CatNameBreadcrm}</a></span>

                                {/* <span><a href={service.getRedirectUrl(`/coloring-pages-printables/${this.props.location.pathname.split("?")[0].split('/')[2]}/`)} className="R11_9e">{this.props.location.pathname.split("?")[0].split('/')[2].split("-").join(" ")}</a></span> */}

                                <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                                {this.state.selectedDeskCat && this.state.selectedDeskCat != "" &&
                                    <span>{this.state.selectedDeskCat}</span>
                                }
                            </div>
                            }
                            <h1 className="B24_00 left" id="skipToH1" role="heading" tabIndex="0">{this.state.seoData && this.state.seoData != "" && this.state.seoData[0].hedding != "" ? this.state.seoData[0].hedding : ''}</h1>
                            <div className="right filter" onClick={() => action.openCatgFilter(this)} tabIndex={0} role="button" aria-label="Filter"  onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault(); // stop page scroll on Space
                            
                                  action.openCatgFilter(this);
                            
                                  // move focus to close button inside popup
                                  setTimeout(() => {
                                    const popupFocus = document.querySelector(
                                      ".catgFilter-top .close-ic[tabindex]"
                                    );
                                    if (popupFocus) popupFocus.focus();
                                  }, 0);
                                }
                              }}>
                                <span data-icon-font="K" className="icon M16_42 Dev_Fltr_icn"></span>
                                <span className="M16_42 Dev_Fltr_btn">Filter</span>
                            </div>
                            <input type="hidden" id="pgNo" value="" />
                        </div>
                        <div className="sub-container left">
                            <div className="data-container left">
                                {this.state.initialData ?
                                    <div>
                                        <ColoringDesktopView eleRef={this} />
                                        <ColoringMobileView eleRef={this} />
                                        {/* <div className="category-info-block" dangerouslySetInnerHTML={{__html: (this.state.seoData && this.state.seoData[0] && this.state.seoData[0].editor) ? this.state.seoData[0].editor : '' }}></div>
                                    {(this.state.windowInner < 767) &&
                                        this.state.seoData && this.state.seoData != "" && this.state.seoData[0].supportiveContent != "" &&
                                        <div>
                                            <div className="topMbl-catdescp"><div className="topMbl-category-descp R14_61">
                                                {this.state.seoData && this.state.seoData[0] && this.state.seoData[0].supportiveContent}
                                            </div>
                                                <span className="read-more-less M12_link" onClick={(e) => action.readMore(e)}>Read More</span>
                                            </div>
                                            {this.state.seoData[0].bottomDescription != "" && this.state.seoData[0].bottomDescription.length > 1  &&
                                                <div className="topMbl-catdescp"><div className="topMbl-category-descp R14_61">
                                                    {this.state.seoData[0].bottomDescription}
                                                    </div>
                                                    <span className="read-more-less M12_link" onClick={(e) => action.readMore(e)}>Read More</span>
                                                </div>
                                            }
                                        </div>
                                            } */}
                                        {(this.state.windowInner < 767) ?
                                            this.state.seoData && this.state.seoData != "" && this.state.seoData[0].supportiveContent != "" &&
                                            <div>
                                                {!this.state.isApp ? <div className="msite-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                                    <div style={{ textAlign: "center", padding: "5px" }} >ADVERTISEMENT</div>
                                                    {/* <GPT
                                                        adUnitPath={gptAry['msite']['path']}
                                                        slotSize={gptAry['msite']['slot']}
                                                        renderWhenViewable={false}
                                                    /> */}
                                                     <DFPSlotsProvider
                                                    dfpNetworkId={gptAry['msite']['id']}
                                                    adUnit={gptAry['msite']['path']}
                                                    slotSize={gptAry['msite']['slot']}
                                                    renderWhenViewable={false}
                                                ></DFPSlotsProvider>
                                                </div> : ''}
                                                
                                                <div className="category-info-block">
                                                    <div className="R14_61">
                                                        {this.state.seoData && this.state.seoData[0] && this.state.seoData[0].supportiveContent}
                                                    </div>
                                                </div>
                                                {this.state.seoData && this.state.seoData[0] && this.state.seoData[0].editor &&
                                                    <div className="category-info-block">
                                                        <div className="R14_61" dangerouslySetInnerHTML={{ __html: (this.state.seoData && this.state.seoData[0] && this.state.seoData[0].editor) ? this.state.seoData[0].editor : '' }}>
                                                        </div>
                                                    </div>
                                                }

                                                {this.state.seoData[0].bottomDescription != "" && this.state.seoData[0].bottomDescription.length > 1 &&
                                                    <div className="category-info-block">
                                                        {/* <div className="R14_61"> */}
                                                        <div className="R14_61" dangerouslySetInnerHTML={{ __html: (this.state.seoData && this.state.seoData[0] && this.state.seoData[0].bottomDescription) ? this.state.seoData[0].bottomDescription : '' }}>
                                                        </div>
                                                    </div>
                                                }


                                                {/* <div>
                                                <div className="category-info-block R14_61" dangerouslySetInnerHTML={{ __html: (this.state.seoData && this.state.seoData[0] && this.state.seoData[0].editor) ? this.state.seoData[0].editor : '' }}>
                                                </div>
                                            </div> */}
                                            </div>
                                            : <div className="category-info-block R14_61" dangerouslySetInnerHTML={{ __html: (this.state.seoData && this.state.seoData[0] && this.state.seoData[0].editor) ? this.state.seoData[0].editor : '' }}></div>
                                        }
                                    </div>
                                    :
                                    <NoResult />
                                }
                            </div>
                        </div>
                    </div>
                </main >
            </div>
        )
    }
}

export default withContext(ColoringSubCatDetails);
